import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CardBody, CardTitle, Col, FormGroup, Input, Label, Row, Button, Collapse, Spinner } from 'reactstrap';
import WizardError from '../../auth/register/WizardError';
import Flex from '../../common/Flex';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { changeUserPassword } from '../../../helpers/api/auth';
import handleErrorMessage from '../../../helpers/errors/handleErrorMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SUCCESS_RESPONSE } from '../../../helpers/codeResponses/codes';
import { Toast } from '../../UI/toast/Toast';

const ProfilePasswordAdmin = ({ data, username }) => {
    const [password, setPassword] = useState({ value: '', error: '' });
    const [changePassword, setChangePassword] = useState(false);
    const [newPassword, setNewPassword] = useState({ value: '', error: '' });
    const [confirmPassword, setConfirmPassword] = useState({ value: '', error: '' });
    const [submitting, setSubmitting] = useState(false);
    const { value: pass } = password;
    const { value: newPass } = newPassword;
    const { value: confirm } = confirmPassword;

    useEffect(() => {
        if (newPass.length > 0 && newPass.length < 8) {
            setNewPassword(prev => ({ ...prev, error: 'La contraseña debe tener al menos 8 carácteres.' }));
        } else {
            if (pass === newPass) {
                setNewPassword(prev => ({ ...prev, error: 'Ingrese una contraseña diferente.' }));
            } else {
                setNewPassword(prev => ({ ...prev, error: '' }));
            }
            setNewPassword(prev => ({ ...prev, error: '' }));
        }
        if (confirm.length > 0 && confirm.length < 8) {
            setConfirmPassword(prev => ({ ...prev, error: 'La contraseña debe tener al menos 8 carácteres.' }));
        } else {
            if (confirm !== newPass) {
                if (pass === confirm) {
                    setConfirmPassword(prev => ({ ...prev, error: 'Ingrese una contraseña diferente.' }));
                } else {
                    setConfirmPassword(prev => ({ ...prev, error: 'Las contraseñas deben ser iguales.' }));
                }
                setConfirmPassword(prev => ({ ...prev, error: 'Las contraseñas deben ser iguales.' }));
            } else {
                if (pass === confirm) {
                    setConfirmPassword(prev => ({ ...prev, error: 'Ingrese una contraseña diferente.' }));
                } else {
                    setConfirmPassword(prev => ({ ...prev, error: '' }));
                }
            }
        }
    }, [confirm, newPass, pass]);

    const savePassword = () => {
        setSubmitting(true);
        changeUserPassword({ current_password: pass, new_password: newPass, new_password_confirmation: confirm })
            .then(({ code }) => { if (code === SUCCESS_RESPONSE.OK) Toast.fire({ type: 'success', title: `Contraseña actualizada exitosamente.`, }); })
            .catch(error => handleErrorMessage(error))
            .finally(() => {
                setSubmitting(false);
                setPassword({ value: '', error: '' });
                setNewPassword({ value: '', error: '' });
                setConfirmPassword({ value: '', error: '' });
                setChangePassword(false);
            });
    }

    return (
        <Fragment>
            <CardBody className='pb-0'>
                <CardTitle tag='h5'>
                    Información de acceso
                </CardTitle>
                <Row form>
                    <Col tag={FormGroup}>
                        <Label>Nombre de usuario</Label>
                        <Label className='form-control'>{username}</Label>
                    </Col>
                </Row>
            </CardBody>
        </Fragment>
    )
}

ProfilePasswordAdmin.propTypes = {
    data: PropTypes.object.isRequired,
    username: PropTypes.string
};

export default ProfilePasswordAdmin;